import { render } from "./MsightNav.vue?vue&type=template&id=bab21840&scoped=true"
import script from "./MsightNav.vue?vue&type=script&lang=js"
export * from "./MsightNav.vue?vue&type=script&lang=js"

import "./MsightNav.vue?vue&type=style&index=0&id=bab21840&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab21840"]])

export default __exports__